import { useMemo } from 'react';
import { useFeature } from '../../context/AppSettingsData';

export interface UseTimeFormatResult {
    is12HourClock: boolean;
    timeFormat: string | undefined;
}

const detectIs12HourClock = (timeFormat?: string): boolean =>
    Boolean(timeFormat && (timeFormat.includes('a') || timeFormat.includes('h')));

export const useTimeFormat = (): UseTimeFormatResult => {
    const timeFormat = useFeature('localization')?.timeFormat;
    return useMemo(
        () => ({
            is12HourClock: detectIs12HourClock(timeFormat),
            timeFormat,
        }),
        [timeFormat]
    );
};
